import { gql } from '@apollo/client';

export const SellerLeadFragment = gql`
  fragment SellerLeadFragment on OdProtosSellSellerData_Lead {
    id
    productOfferings {
      product
      deniedAt
      denialReason
    }
    address {
      market
      postalCode
      street
      city
      state
      uuid
      latitude
      longitude
      timeZone
      unitNumber
    }
    channel
    customerV2 {
      uuid
      fullName
      primaryEmail {
        address {
          value
        }
      }
      primaryPhoneNumber {
        number {
          value
        }
      }
    }
    region
    sellerDetails {
      annualIncomeCents
      creditScoreRange {
        min
        max
      }
      downPaymentCents
      monthlyDebtsCents
      timeline
      goalPriceCents
      hasVisitedHub
    }
    source {
      id
    }
    experimentEntityId
  }
`;
